import { useNavigate } from 'react-router-dom'
import routes from '../../config/settings/routes'
import { brand } from '../../config/settings/brand'
import BrandLogo from '../../components/Brand/BrandLogo'
import {
  SidebarBrand,
  BrandName
} from './Sidebar.styles'

const Brand = () => {
  const navigate = useNavigate()

  const handleOnGoInit = () => {
    navigate(routes.dashboard)
  }

  return (
    <SidebarBrand onClick={handleOnGoInit} aria-label={`Ir al inicio — ${brand.name}`}>
      <BrandLogo size={30} />
      <BrandName>{brand.name}</BrandName>
    </SidebarBrand>
  )
}

export default Brand
